import { render, staticRenderFns } from "./Suspendable.vue?vue&type=template&id=2ba1042c&"
import script from "./Suspendable.vue?vue&type=script&lang=js&"
export * from "./Suspendable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports